/**
 * @generated SignedSource<<96bb62ad9470855f839d5461a33770f9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutGuestBuyerQueryRenderer_preCheckoutTransaction$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutDeliveryOptionsQueryRenderer_preCheckoutTransaction" | "useBuyerFetchHandler_preCheckoutTransaction">;
  readonly " $fragmentType": "CheckoutGuestBuyerQueryRenderer_preCheckoutTransaction";
};
export type CheckoutGuestBuyerQueryRenderer_preCheckoutTransaction$key = {
  readonly " $data"?: CheckoutGuestBuyerQueryRenderer_preCheckoutTransaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutGuestBuyerQueryRenderer_preCheckoutTransaction">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutGuestBuyerQueryRenderer_preCheckoutTransaction",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutDeliveryOptionsQueryRenderer_preCheckoutTransaction"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useBuyerFetchHandler_preCheckoutTransaction"
    }
  ],
  "type": "Transaction",
  "abstractKey": null
};

(node as any).hash = "147d323f9ba3f2a103e39912aad6dd12";

export default node;
